<script lang="ts">
    import { onDestroy } from 'svelte';
    import Regex from '../../lib/regex';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '';
    export let disabled: boolean = false;

    errors[name] = [];

    const validate = (val: string = value) => {
        errors[name] = [];
        if (!Regex.IPv4.test(val)) {
            errors[name].push('Invalid IP address');
        }
    };
    validate();

    const handleInput = (e: Event) => validate((e.currentTarget as HTMLInputElement).value);

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <input
        type="text"
        {name}
        bind:value
        on:input={handleInput}
        class="input-mono"
        class:error={errors[name].length > 0}
        inputmode="numeric"
        placeholder="192.168.1.1"
        {disabled}
        required
        on:change
    />
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
